import { render, staticRenderFns } from "./ClassSlidebar.vue?vue&type=template&id=2de8d286"
import script from "./ClassSlidebar.vue?vue&type=script&lang=js"
export * from "./ClassSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports